exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-box[data-v-886d17be]{width:100%;height:68px;padding:19px 0;line-height:30px;color:#fff;background:#424456;box-sizing:border-box;text-align:center}.footer-box .footer-logo[data-v-886d17be]{width:105px;height:30px;margin-right:50px;opacity:.7}.footer-box .footer-logo[data-v-886d17be],.footer-box span[data-v-886d17be]{display:inline-block;vertical-align:middle}.footer-box .footer-space[data-v-886d17be]{margin:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-886d17be","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/e-footer.vue
// module id = 710
// module chunks = 0